import { useEffect } from 'react';

export const useKeyDown = (key, action) => {
  useEffect(() => {
    function onKeyUp(event) {
      if (event?.key === key) {
        action();
      }
    }
    window.addEventListener('keydown', onKeyUp);

    return () => window.removeEventListener('keydown', onKeyUp);
  }, [action, key]);
};
